import React, { useState, useEffect, useRef } from "react";

import { RegisterModalData, RegisterModalObserver, SetModalState } from "interface/PopUp";

import './popUp.css';

export default function PopUP_ShowFile(props){

    const videoRef = useRef(null);
    const playCount = useRef(0);
    const [ modalData, setModaldata ] = useState({});
    const [ showPopUp, setShowPopUp ] = useState(false);

    function ClosePopUp(){
        SetModalState('ShowFile', false);
    }

    useEffect(()=>{
        RegisterModalData('ShowFile', setModaldata);
        RegisterModalObserver('ShowFile', setShowPopUp);
    }, []);

    function handleVideoEnded(){
        playCount.current += 1;
        if(playCount.current < 3){
            videoRef.current.play().catch(err => console.log('Erro ao reproduzir vídeo:', err));
        } else {
            playCount.current = 0;
            ClosePopUp();
        }
    }

    useEffect(()=>{
        if(showPopUp){
            playCount.current = 0;
            if(videoRef.current){
                videoRef.current.play().catch(err => console.log('Erro ao reproduzir vídeo:', err));
            }
        }
    }, [showPopUp]);

    return (
        (showPopUp ?
            <div className="PopUp">
                <div className="all show_file">
                    <div className="close" onClick={ ()=>{ ClosePopUp(); } }>
                        <svg viewBox="0 0 24 24" className="icone_home">
                            <path d="M12 5.69L17 10.19V18H15V12H9V18H7V10.19L12 5.69M12 3L2 12H5V20H11V14H13V20H19V12H22" fill="#ffffff" />
                        </svg>
                    </div>

                    <div className="div_data">
                        <video ref={ videoRef } width="100%" height="100%" autoPlay playsInline onEnded={ handleVideoEnded }>
                            <source src={ modalData.file } type="video/mp4" />
                        </video>
                    </div>
                </div>
                <div className="close_all" onClick={ ()=>{ ClosePopUp(); } } />
            </div>
        : <React.Fragment></React.Fragment>)
    );
}
